import * as React from 'react';
import { Tooltip } from '@iba-team/portal-react-components/dist';
import BusinessIcon from '../../assets/icons/leaveTypes/business-trip.svg';

export const BusinessCell = () => <div className={'default_cell_container'}>
  <div className={'drag_container'}>
    <Tooltip title={'Business trip'}>
      <img src={BusinessIcon} alt={'businessTrip'}/>
    </Tooltip>
  </div>
</div>;